import React from 'react';
import { PolicyVersion } from '../../../common';
import Share from './PolicyShare';
import Options from '../Options';
import { CLONE_LIMIT } from '../../constants';
import { Shares } from './styled';
import { IResource, IPolicyVersion } from '../../types';

const getShares = (version: IPolicyVersion, resources: IResource[]) => (
  <Shares>
    <table>
      <thead>
        <tr>
          <th>Share</th>
          <th>Primary Resource</th>
          <th>Backup Resource(s)</th>
        </tr>
      </thead>
      <tbody>
        {version.shares.map((share) => (
          <Share key={share.id} share={share} resources={resources} />
        ))}
      </tbody>
    </table>
  </Shares>
);

const ExpandedItem = ({ policy, sortable, resources, canEdit }) => {
  return (
    <>
      {policy.versions
        .sort((a, b) => {
          if (a.is_active) {
            return -1;
          } else if (b.is_active) {
            return 1;
          } else {
            return a.id < b.id ? -1 : 1;
          }
        })
        .map((version) => {
          const shares = getShares(version, resources);

          const options = (
            <Options
              policy={policy}
              version={version}
              canClone={policy.versions.length < CLONE_LIMIT}
            />
          );

          return (
            <PolicyVersion
              key={version.id}
              policy={policy}
              version={version}
              canEdit={canEdit}
              options={options}
            >
              {shares}
            </PolicyVersion>
          );
        })}
    </>
  );
};

export default ExpandedItem;
